import React, { useState } from 'react'
import { Link } from 'gatsby'
import styled, { createGlobalStyle } from 'styled-components'
import { FaLinkedin, FaCaretDown } from 'react-icons/fa'
import FloatingWhatsAppButton from './wa-widget';

const GlobalStyle = createGlobalStyle`
  @import url('https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;700&display=swap');

  body {
    font-family: 'Roboto', sans-serif;
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    color: #333333;
    line-height: 1.6;
  }
`

const Layout = ({ children }) => {
  const [isProductsDropdownOpen, setIsProductsDropdownOpen] = useState(false)
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)

  const openCalendly = () => {
    if (typeof window !== 'undefined' && window.Calendly) {
      window.Calendly.initPopupWidget({url: 'https://calendly.com/burbuxa-felipe/2024'});
    }
  }

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen)
  }

  return (
    <>
      <GlobalStyle />
      <Header>
        <a href="/">
          <Logo src="https://burbuxa.sfo3.cdn.digitaloceanspaces.com/home-logo.webp" alt="Burbuxa logo" />
        </a>
        <DesktopNav>
          <NavLink to="/">Home</NavLink>
          <NavItemWithDropdown 
            onMouseEnter={() => setIsProductsDropdownOpen(true)}
            onMouseLeave={() => setIsProductsDropdownOpen(false)}
          >
                    <NavLink as="span">
            Productos <FaCaretDown />
        </NavLink>
            {isProductsDropdownOpen && (
              <Dropdown>
                <DropdownLink to="/burbujita">Agente IA - Burbujita</DropdownLink>
                <DropdownLink to="/reviews">Reviews por WhatsApp</DropdownLink>
                <DropdownLink to="/conversion">Flujos de conversión</DropdownLink>
                <DropdownLink to="/transactional">Flujos transaccionales</DropdownLink>
                <DropdownLink to="/campaigns">Campañas segmentadas</DropdownLink>
              </Dropdown>
            )}
          </NavItemWithDropdown>
          <NavLink to="/blog">Blog</NavLink>
          <NavCta onClick={openCalendly}>Contáctanos</NavCta>
        </DesktopNav>
        <MobileMenuButton onClick={toggleMobileMenu}>☰</MobileMenuButton>
      </Header>
      {isMobileMenuOpen && (
        <MobileNav>
          <NavLink to="/" onClick={() => setIsMobileMenuOpen(false)}>Home</NavLink>
          <NavLink to="/burbujita" onClick={() => setIsMobileMenuOpen(false)}>Agente IA - Burbujita</NavLink>
          <NavLink to="/reviews" onClick={() => setIsMobileMenuOpen(false)}>Reviews por WhatsApp</NavLink>
          <NavLink to="/conversion" onClick={() => setIsMobileMenuOpen(false)}>Flujos de conversión</NavLink>
          <NavLink to="/transactional" onClick={() => setIsMobileMenuOpen(false)}>Flujos transaccionales</NavLink>
          <NavLink to="/campaigns" onClick={() => setIsMobileMenuOpen(false)}>Campañas segmentadas</NavLink>
          <NavLink to="/blog" onClick={() => setIsMobileMenuOpen(false)}>Blog</NavLink>
          <NavCta onClick={openCalendly}>Contáctanos</NavCta>
        </MobileNav>
      )}
      <FloatingWhatsAppButton />
      <main>{children}</main>
      <Footer>
        <FooterContent>
          <FooterSection>
            <FooterTitle>Burbuxa</FooterTitle>
            <FooterLink to="/blog">Blog</FooterLink>
            <FooterLink to="/terms-of-service">Terms of Service</FooterLink>
            <FooterLink to="/privacy-policy">Privacy Policy</FooterLink>
          </FooterSection>
          <FooterSection>
            <FooterTitle>Productos</FooterTitle>
            <FooterLink to="/burbujita">Empleado IA - Burbujita</FooterLink>
            <FooterLink to="/reviews">Reviews por WhatsApp</FooterLink>
            <FooterLink to="/conversion">Flujos de conversión</FooterLink>
            <FooterLink to="/transactional">Flujos transaccionales</FooterLink>
            <FooterLink to="/campaigns">Campañas segmentadas</FooterLink>
          </FooterSection>
          <FooterSection>
            <FooterTitle>Empresa</FooterTitle>
            contacto@burbuxa.com<br></br>
            Burbuxa fue conocida previamente como WhataCart
            Respaldados por Newtopia VC, Andrés y Daniel Bilbao, entre otros.
            
            <SocialIcons>
              <SocialIconLink href="https://linkedin.com/company/burbuxa" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn"><FaLinkedin /></SocialIconLink>
            </SocialIcons>
          </FooterSection>
        </FooterContent>
        <Copyright>© {new Date().getFullYear()} Alacua LLC. Todos los derechos reservados.</Copyright>
      </Footer>
    </>
  )
}

const Header = styled.header`
  position: sticky;
  top: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 2rem;
  background-color: rgb(35, 36, 38);
  z-index: 1000;

  @media (max-width: 768px) {
    flex-wrap: wrap;
  }
`

const Logo = styled.img`
  height: 40px;
  margin-top: 0.5rem;
  margin-left: 1rem;
`

const DesktopNav = styled.nav`
  display: flex;
  gap: 1.5rem;
  align-items: center;

  @media (max-width: 768px) {
    display: none;
  }
`

const MobileNav = styled.nav`
  display: none;
  align-items: center;
  padding-bottom: 1rem;
  z-index: 999;
  position: fixed;
  background-color: rgb(35, 36, 38);

  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 1rem;
    padding-top: 1rem;
  }
  &:hover {
    color: #edba26;
  }
`

const NavLink = styled(Link)`
  font-family: 'Roboto', sans-serif;
  font-size: 1rem;
  color: #fff;
  text-decoration: none;
  font-weight: 500;
  padding-left: 0.5rem;
  
  &:hover {
    color: #edba26;
  }
`

const NavItemWithDropdown = styled.div`
  position: relative;
  cursor: pointer;
`

const Dropdown = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  background-color: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  min-width: 200px;
  z-index: 10;
`

const DropdownLink = styled(Link)`
  font-family: 'Roboto', sans-serif;
  color: #383A43;
  text-decoration: none;
  padding: 0.5rem 1rem;
  
  &:hover {
    background-color: #edba26;
    color: #fff;
  }
`

const MobileMenuButton = styled.button`
  display: none;

  @media (max-width: 768px) {
    display: block;
    background: none;
    border: none;
    font-size: 1.5rem;
    cursor: pointer;
    color: #fff;
  }
`

const NavCta = styled.button`
  background-color: #BD1EEB;
  color: #fff;
  font-family: 'Futura', sans-serif;
  font-size: 1rem;
  padding: 1rem 1.5rem;
  border: none;
  border-radius: 4px;
  max-width: 80%;
  cursor: pointer;
  transition: background-color 0.3s, transform 0.3s;
  
  &:hover {
    background-color: #7A1EEB;
    transform: scale(1.05);
  }

  @media (max-width: 768px) {
    width: 100%;
  }
`

const Footer = styled.footer`
  background-color: #383A43;
  color: #fff;
  padding: 4rem 2rem 2rem;
`

const FooterContent = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  max-width: 1200px;
  margin: 0 auto;
`

const FooterSection = styled.div`
  flex: 1;
  width: 400px;
  margin-bottom: 2rem;
  align-items: left;
`

const FooterTitle = styled.h3`
  font-family: 'Roboto', sans-serif;
  font-size: 1.2rem;
  margin-bottom: 1rem;
`

const FooterText = styled.p`
  margin-bottom: 1rem;
  max-width: 250px;
`

const FooterLink = styled(Link)`
  display: block;
  color: #fff;
  text-decoration: none;
  margin-bottom: 0.5rem;
  
  &:hover {
    text-decoration: underline;
  }
`

const SocialIcons = styled.div`
  display: flex;
  gap: 1rem;
`

const SocialIconLink = styled.a`
  color: #fff;
  font-size: 1.5rem;
  transition: color 0.3s;

  &:hover {
    color: #edba26;
  }
`

const Copyright = styled.p`
  text-align: center;
  margin-top: 2rem;
  font-size: 0.9rem;
`

export default Layout